// A Meta responde o erro em inglês e em vocabulário de API, e esse texto ia cru para o
// tooltip do horário — sem dizer ao atendente o que fazer.
//
// A tradução é na exibição, não na gravação: Messages.motivo guarda o texto original (é
// dele que sai qualquer investigação) e traduzir aqui vale para o que já está no banco.
const MOTIVOS = [
  {
    casa: /application\/octet-stream|choose a different file/i,
    texto: "O WhatsApp recusou este áudio. Grave o áudio de novo — se ele vier de uma resposta rápida, recadastre a resposta rápida.",
  },
  {
    casa: /more than 24 hours have passed/i,
    texto: "O cliente não responde há mais de 24 horas. Nessa situação o WhatsApp só entrega mensagem por modelo (template).",
  },
  {
    casa: /account has been locked/i,
    texto: "A conta do WhatsApp Business está bloqueada pela Meta. Fale com o suporte.",
  },
  {
    casa: /currency is not configured/i,
    texto: "A conta do WhatsApp Business está sem moeda configurada no Gerenciador da Meta.",
  },
  {
    casa: /no payment method is set up/i,
    texto: "A conta do WhatsApp Business está sem forma de pagamento cadastrada no Gerenciador da Meta.",
  },
  {
    casa: /^\s*message undeliverable/i,
    texto: "O WhatsApp não conseguiu entregar a mensagem. Confira se o número existe e tem WhatsApp.",
  },
];

// Devolve o texto em português quando o motivo é conhecido; senão o próprio motivo,
// para nunca esconder um erro novo que a Meta comece a mandar.
export const motivoFalhaEnvio = (motivo) => {
  if (!motivo) return motivo;
  const encontrado = MOTIVOS.find(m => m.casa.test(motivo));
  return encontrado ? encontrado.texto : motivo;
};

export default motivoFalhaEnvio;
